import { EventEmitter } from 'events';

export const eventEmitter = new EventEmitter();

export const emitEvent = (eventName: string, eventValue: any) => {
    eventEmitter.emit(eventName, eventValue);
};

export const addEventListener = (eventName: string, listener: (value: any) => void) => {
    eventEmitter.on(eventName, listener);
};

export const removeEventListener = (eventName: string, listener: (value: any) => void) => {
    eventEmitter.off(eventName, listener);
};

export const removeAllEventListeners = (eventName: string) => {
    eventEmitter.removeAllListeners(eventName);
};
//export const removeAllListeners('eventName');